import { useMemo } from 'react';
import { ShareDialog } from './ShareDialog.web';
import { useCVData } from '../../lib/cv-mock-data';
import { buildPublicCvRouteUrl } from '../../lib/public-web';

interface CvShareBottomSheetProps {
  visible: boolean;
  onClose: () => void;
  publicUrl?: string | null;
}

export function CvShareBottomSheet({
  visible,
  onClose,
  publicUrl,
}: CvShareBottomSheetProps) {
  const { profile } = useCVData();
  const resolvedPublicUrl = useMemo(
    () => publicUrl ?? (profile.username ? buildPublicCvRouteUrl(profile.username) : null),
    [profile.username, publicUrl],
  );

  if (!visible) return null;

  return (
    <ShareDialog
      url={resolvedPublicUrl}
      profileName={profile.name}
      accentColor={undefined}
      onClose={onClose}
    />
  );
}
